export default "__VITE_ASSET__DmkE2Xzu__"